import { PayloadAction } from "@reduxjs/toolkit";
import { StockPublicationSliceState } from "../../types";

export const quantityReducers = {
  setMaxVisibleQuantity: (
    state: StockPublicationSliceState,
    action: PayloadAction<number | null>,
  ) => {
    if (state.draftSettings) {
      state.draftSettings.maxVisibleQuantity = action.payload;
    }
  },
  setHideLastFullSet: (
    state: StockPublicationSliceState,
    action: PayloadAction<boolean>,
  ) => {
    if (state.draftSettings) {
      state.draftSettings.hideLastFullSet = action.payload;
    }
  },
};
